import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesService {
  private sources = new Set<() => boolean>();
  private lastDecision: { navigationId: number; allowed: boolean } | null = null;

  private readonly onBeforeUnload = (event: BeforeUnloadEvent) => {
    if (!this.hasUnsavedChanges()) {
      return;
    }

    event.preventDefault();
    event.returnValue = '';
  };


  register(isDirty: () => boolean): () => void {
    this.sources.add(isDirty);

    if (this.sources.size === 1) {
      window.addEventListener('beforeunload', this.onBeforeUnload);
    }

    return () => {
      this.sources.delete(isDirty);

      if (this.sources.size === 0) {
        window.removeEventListener('beforeunload', this.onBeforeUnload);
      }
    };
  }


  hasUnsavedChanges(): boolean {
    return [...this.sources].some(isDirty => isDirty());
  }


  getDecision(navigationId: number): boolean | null {
    return this.lastDecision?.navigationId === navigationId ? this.lastDecision.allowed : null;
  }


  setDecision(navigationId: number, allowed: boolean) {
    this.lastDecision = {navigationId, allowed};
  }
}
